import { StyleSheet, ImageBackground } from "react-native";
import React from "react";
import { Modal, VStack, View } from "native-base";
import { colors } from "../../../styles/GlobalStyle";
import { H5, Txt } from "../../TextsComponents";
import DimensionsHook from "../../../hooks/DimensionsHook";

import { useTranslation } from "react-i18next";
import { PrimaryButton, SecondaryButton } from "../../Buttons";
import { AntDesign } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useSelector } from "react-redux";

const NavigateToWelcomeQuestionnaire = ({ isOpen, setIsOpen, navigation }) => {
  const { t } = useTranslation();
  const { isMobile } = DimensionsHook();

  const closeHandler = () => {
    setIsOpen(false);
  };

  const questionnairesData = useSelector((state) => state.questionnairesData);
  const welcomeQuestionnaire = questionnairesData.find(
    (el) => el.welcome == true
  );
  if (!welcomeQuestionnaire) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={closeHandler}>
      <Modal.Content style={styles.container}>
        <Modal.Body>
          <ImageBackground
            source={require("../../../assets/background.png")}
            style={{ flex: 1 }}
          >
            <Modal.CloseButton focusable={false} />
            <VStack
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: 20 }}
            >
              <Txt
                style={{
                  textAlign: "center",
                  marginHorizontal: isMobile ? 20 : 30,
                  marginTop: 50,
                }}
              >
                {welcomeQuestionnaire.description}
              </Txt>
              <View style={{ marginVertical: 30 }}>
                <PrimaryButton
                  onPress={() => {
                    setIsOpen(false);

                    navigation.navigate("Questionnaire", welcomeQuestionnaire);
                  }}
                >
                  {t("questionnaires.button")}
                </PrimaryButton>
                <SecondaryButton
                  style={{ marginTop: 15 }}
                  onPress={async () => {
                    await AsyncStorage.setItem("amont_welcome", "true");
                    setIsOpen(false);
                  }}
                >
                  {t("questionnaires.not_show")}
                </SecondaryButton>
              </View>
            </VStack>
          </ImageBackground>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default NavigateToWelcomeQuestionnaire;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    width: "95%",
    maxWidth: 600,
    maxHeight: 5000,
  },
});
